import { useScrollState } from "@/hooks/useScrollState";

export default function ScrollTools() {
  const { progress, passed } = useScrollState(400);

  return (
    <>
      <div
        className="fixed left-0 top-0 z-[60] h-0.5 w-full bg-transparent"
        aria-hidden="true"
      >
        <div
          className="h-0.5 bg-accent-500 transition-[width] duration-150"
          style={{ width: `${progress}%` }}
        />
      </div>

      {passed && (
        <button
          type="button"
          aria-label="返回页面顶部"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="fixed bottom-6 right-4 z-50 flex h-11 w-11 items-center justify-center rounded-full border border-background-300 bg-background-50 text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-700 md:right-6"
        >
          <i className="ri-arrow-up-line text-lg" aria-hidden="true" />
        </button>
      )}
    </>
  );
}